import { Component, Input, OnInit, OnChanges, SimpleChanges } from "@angular/core";
import { toNumber } from "lodash";

@Component({
  selector: "app-default-image",
  templateUrl: "./default-image.component.html",
  styleUrls: ["./default-image.component.scss"],
  standalone: false,
})
export class DefaultImageComponent implements OnInit, OnChanges {
  @Input() src: string = '';
  @Input() defaultSrc: string = 'assets/img/user.png';
  @Input() alt: string = 'Image';
  @Input() cssClass: string = '';
  @Input() width: string = 'auto';
  @Input() height: string = 'auto';
  @Input() name: string = '';
  @Input() showInitials: boolean = true;
  @Input() initialsColor: string = '#ffffff';
  @Input() initialsBgColor: string = '#007bff';
  @Input() fontSize: string = 'auto';
  @Input() letterSpacing: string = 'auto';
  @Input() shadow: boolean = false;
  @Input() rounded: boolean = false;
  @Input() circle: boolean = false;
  @Input() responsive: boolean = false;
  imageError: boolean = false;
  initials: string = '';

  constructor() { }

  ngOnInit() {
    this.updateInitials();
  }

  ngOnChanges(changes: SimpleChanges) {
    // Détecter les changements de name ou showInitials
    if (changes['name'] || changes['showInitials']) {
      this.updateInitials();
    }

    // Réinitialiser l'erreur d'image si la source change
    if (changes['src'] && changes['src'].currentValue !== changes['src'].previousValue) {
      this.imageError = false;
    }
  }

  private updateInitials() {
    if (this.name && this.showInitials) {
      this.initials = this.generateInitials(this.name);
    } else {
      this.initials = '';
    }
  }

  onImageError() {
    this.imageError = true;
  }

  onImageLoad() {
    this.imageError = false;
  }

  getResolvedSrc(): string {
    if (!this.src) return '';
    const isLocalDev = typeof window !== "undefined" && window.location.hostname === "localhost";
    if (isLocalDev && this.src.startsWith("https://127.0.0.1")) {
      return this.src.replace("https://127.0.0.1", "http://127.0.0.1");
    }
    return this.src;
  }

  generateInitials(name: string): string {
    if (!name || name.trim() === '') return '';

    return name
      .trim()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase())
      .join('')
      .substring(0, 2); // Limiter à 2 caractères maximum
  }

  getInitialsStyle(): any {
    const width = toNumber(this.width.split('px')[0]);
    const fontSize = width > 100 ? '2rem' : '1rem';
    return {
      'background-color': this.initialsBgColor,
      'color': this.initialsColor,
      'width': this.width !== 'auto' ? this.width : '100%',
      'height': this.height !== 'auto' ? this.height : '100%',
      'font-size': this.fontSize !== 'auto' ? this.fontSize : fontSize,
      'letter-spacing': this.letterSpacing !== 'auto' ? this.letterSpacing : '3px',
    };
  }

  getImageClasses(): string {
    let classes = 'default-image';

    if (this.cssClass) {
      classes += ' ' + this.cssClass;
    }

    if (this.rounded) {
      classes += ' rounded';
    }

    if (this.shadow) {
      classes += ' shadow';
    }

    if (this.circle) {
      classes += ' circle';
    }

    if (this.responsive) {
      classes += ' responsive';
    }

    return classes;
  }
}
